import { render, staticRenderFns } from "./ProductRelated.vue?vue&type=template&id=ad27ee1c&scoped=true&"
import script from "./ProductRelated.vue?vue&type=script&lang=js&"
export * from "./ProductRelated.vue?vue&type=script&lang=js&"
import style0 from "./ProductRelated.vue?vue&type=style&index=0&id=ad27ee1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad27ee1c",
  null
  
)

export default component.exports